import React from 'react';

export function EditButton({ onClick, label = 'Düzenle', size = 'sm' }) {
  if (size === 'lg') {
    return (
      <button onClick={onClick}
        className="flex-1 py-4 px-4 rounded-2xl bg-indigo-50 hover:bg-indigo-600 text-indigo-700 hover:text-white text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 border border-indigo-100">
        {label}
      </button>
    );
  }
  return (
    <button onClick={onClick}
      className="px-3 py-1.5 rounded-xl bg-indigo-50 hover:bg-indigo-600 text-indigo-600 hover:text-white text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 border border-indigo-100">
      {label}
    </button>
  );
}

export function DeleteButton({ onClick, label = 'Sil', size = 'sm' }) {
  if (size === 'lg') {
    return (
      <button onClick={onClick}
        className="flex-1 py-4 px-4 rounded-2xl bg-rose-50 hover:bg-rose-600 text-rose-500 hover:text-white text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 border border-rose-100">
        {label}
      </button>
    );
  }
  return (
    <button onClick={onClick}
      className="px-3 py-1.5 rounded-xl bg-rose-50 hover:bg-rose-600 text-rose-500 hover:text-white text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 border border-rose-100">
      {label}
    </button>
  );
}

export default function ActionButtons({ onEdit, onDelete, editLabel = 'Düzenle', deleteLabel = 'Sil', size = 'sm' }) {
  return (
    <div className="flex items-center justify-end gap-2">
      {onEdit && <EditButton onClick={onEdit} label={editLabel} size={size} />}
      {onDelete && <DeleteButton onClick={onDelete} label={deleteLabel} size={size} />}
    </div>
  );
}
